import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import mask from 'jquery-mask-plugin'

let qrcode = require('qrcode')

export default class extends Controller {
        patientId


/*
* serviceWorkerRegistration.pushManager.getSubscription().then((sub)=>sub.unsubscribe())
* */
    askPermission() {
        if (Notification.permission === "granted"){
            this.initPush();
            return
        }
        let self = this;
       Notification.requestPermission().then( (permissionResult)=> {
           if (permissionResult === 'granted') {
               self.initPush();
           }
       })
    }

    push(){
        if ("serviceWorker" in navigator && "PushManager" in window) {
            navigator.permissions.query({name:'push', userVisibleOnly:true}).then((status)=>{
                //console.debug(status);
                status.onchange = ()=>{
                    //console.debug(status.state)
                }
            })
            navigator.serviceWorker.register("sw.js")
                .then((sw) => {
                    console.log("Service Worker registered: ", sw);
                    global.serviceWorkerRegistration = sw;
                    this.askPermission()
                   /* this.initPush();*/
                })
                .catch((registrationError) => {
                    console.error("Service Worker registration failed: ", registrationError);
                });
        }
    }

    initPush(){
        let self = this;
        global.serviceWorkerRegistration.pushManager.getSubscription()
            .then(function(subscription) {
                global.hasSubscription = !(subscription === null);
                //console.debug(JSON.stringify(subscription));
                if (!global.hasSubscription){
                    self.subscribeUser();
                }
            });

    }

    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    subscribeUser() {
        let self = this;
        global.serviceWorkerRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: self.urlB64ToUint8Array(global.appServerKey)
        })
            .then(function(subscription) {
                //console.debug(subscription);

                fetch('https://api.actualoptic.kz:8443/admin/subscribe',{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ClientsUserId: Number(self.patientId), subscription: subscription})
                })
                    .then(function(response) {
                        //console.log(response)
                        return response;
                    })
                    .then(function(json) {
                        //console.log('User is subscribed.');
                        //console.log(json)
                        global.hasSubscription = true;
                        fetch('https://api.actualoptic.kz:8443/patient/push/status/'+ usertoken +'/true',{
                            method: 'get',

                        })

                    })
                    .catch(function(error) {
                        global.hasSubscription = false;
                        console.error('error fetching subscribe', error);
                    });
            })
            .catch(function(err) {
                console.log('Failed to subscribe the user: ', err);
            });
    }

    connect() {
            let self = this;

       /* return;*/
        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/'+ usertoken,
            contentType: "application/json",
            async: false,
            success: function (data) {
                self.patientId = data.patient.ID;
                //console.debug('ID пациента ' + self.patientId)
                $('#cardName').text('' + data.patient.ClientName + ' ' + data.patient.ClientSurname);

                $('#cardPhone').text(+data.patient.Phone).mask('+ 0 (000) 000-00-00');
                $('#cardStatusCurrent').text(data.status.GrupAd);
                $('#cardStatusCurrentSum').text(data.status.ClientSaves).mask('000 000 000 000 000', {reverse: true});


                //считаем проценты для ленты прогресса
                let statusSumPr = (data.status.ClientSaves * 100);
                statusSumPr = (statusSumPr / 1000000).toFixed(1)
                if (data.status.ClientSaves >= 1000000) {
                    statusSumPr = 100;
                } else if (data.status.ClientSaves <= 10000) {
                    statusSumPr = 1;
                }
                $('#cardRangeCurrent').html('<span class="card__range-current" style="width:' + statusSumPr + '%"></span>')

                //считаем остаток денег до статуса BRL (до 1 000 001)
                let cardStatusUntilSum = 1000001 - data.status.ClientSaves;
                if (cardStatusUntilSum < 0) {
                    cardStatusUntilSum = 0;
                    $('#cardRangeUntilBrilliant').hide()
                }
                $('#cardStatusUntilSum').text(cardStatusUntilSum).mask('000 000 000 000 000', {reverse: true});

                let canvasDoc = document.getElementById('canvas');
                qrcode.toCanvas(canvasDoc, '+' + data.patient.Phone, {width: '90'}, function (error) {
                    if (error) console.error(error)
                });
                self.push();


            },
            error(error){
            console.debug(error);
               //window.location.replace("404.html");
            }
        });

        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/promo/to/user/'+self.patientId,
            contentType: "application/json",
            success: function(json){
               console.debug(json);
               $('#promocode').text(json.Code);
            },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
            }
        });


        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/bonus/'+ usertoken,
            contentType: "application/json",
            success: function(data){
                let salesBonus = data.salesBonus;
                if (salesBonus < 1){
                    salesBonus = 0
                }
                let birthdayBonus = data.birthdayBonus;
                if (birthdayBonus < 1){
                    birthdayBonus = 0
                }

                $('#cardBonusPurchases').html(salesBonus).mask('000 000 000 000 000', {reverse: true});
                $('#cardBonusBirthday').html(birthdayBonus).mask('000 000 000 000 000', {reverse: true});
            },
            complete: function () {
                $("#cardBonusPurchases .noData").hide();
                $("#cardBonusBirthday .noData").hide();
            },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
            }
        });
    }
}